class YouTubePlayerStore {
  static players = new Map();

  static addPlayer(videoId, player) {
    this.players.set(videoId, player);
  }

  static pauseAll() {
    this.players.forEach((player) => player.pauseVideo());
  }
}

export default YouTubePlayerStore;
